import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/expansions")({
	component: ExpansionsLayout,
})

function ExpansionsLayout() {
	return <Outlet />
}
